import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import * as VantComponents from 'vant'; // 导入所有组件
import 'vant/lib/index.css';
import router from "./router";
import myTextEllipsis from "@/components/myTextEllipsis.vue";
//引入echarts
// 将当前状态添加到浏览器历史记录中 禁止返回
window.addEventListener('popstate', function() {
  let arr = ['home', 'todayList', 'statisticsDaily', 'weeklyList']
  if(arr.some(item => document.URL.includes(item)))
  history.pushState(null, null, document.URL)
})  
const app = createApp(App);
for (const key in VantComponents) {
  if (Object.prototype.hasOwnProperty.call(VantComponents, key)) {
    const component = VantComponents[key];
    app.component(component.name, component);
  }
}
app.component('my-text-ellipsis', myTextEllipsis)
app.use(router)
app.use(store) 
app.mount('#app')
